import { IAAgentsAPI } from '../../../api/iaAgents';
import {
  SET_IA_AGENT_UI_FLAG,
  SET_IA_AGENTS
} from './types';

const api = new IAAgentsAPI();

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isFetching: true });
    try {
      const response = await api.getClinicByAccountId(accountId);
      commit(SET_IA_AGENTS, response.data);
      commit(SET_IA_AGENT_UI_FLAG, { isFetching: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  create: async ({ commit }, { clinicData }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isCreating: true });
    try {
      const response = await api.createClinic(clinicData);
      commit(SET_IA_AGENT_UI_FLAG, { isCreating: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isCreating: false });
      throw error;
    }
  },

  update: async ({ commit }, { accountId, clinicData }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isUpdating: true });
    try {
      const response = await api.updateClinic(accountId, clinicData);
      commit(SET_IA_AGENT_UI_FLAG, { isUpdating: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isUpdating: false });
      throw error;
    }
  },

  createAssistant: async ({ commit }, { accountId, assistantData }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isCreatingAssistant: true });
    try {
      const response = await api.createAssistant(accountId, assistantData);
      commit(SET_IA_AGENT_UI_FLAG, { isCreatingAssistant: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isCreatingAssistant: false });
      throw error;
    }
  },

  updateAssistant: async ({ commit }, { accountId, assistantId, assistantData }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isUpdatingAssistant: true });
    try {
      const response = await api.updateAssistant(accountId, assistantId, assistantData);
      commit(SET_IA_AGENT_UI_FLAG, { isUpdatingAssistant: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isUpdatingAssistant: false });
      throw error;
    }
  },

  uploadKnowledgeSource: async ({ commit }, { accountId, formData }) => {
    commit(SET_IA_AGENT_UI_FLAG, { isUploadingKnowledgeSource: true });
    try {
      const response = await api.uploadKnowledgeSource(accountId, formData);
      commit(SET_IA_AGENT_UI_FLAG, { isUploadingKnowledgeSource: false });
      return response.data;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isUploadingKnowledgeSource: false });
      throw error;
    }
  },

  deleteKnowledgeSource: async ({ commit }, { accountId, knowledgeSourceId }) => {
    try {
      await api.deleteKnowledgeSource(accountId, knowledgeSourceId);
      commit(SET_IA_AGENT_UI_FLAG, { isUpdating: false });
      commit(SET_IA_AGENT_UI_FLAG, { isRemovingKnowledgeSource: false });
      return true;
    } catch (error) {
      commit(SET_IA_AGENT_UI_FLAG, { isUpdating: false });
      commit(SET_IA_AGENT_UI_FLAG, { isRemovingKnowledgeSource: false });
      throw error;
    }
  },
};